import { CampaignsOutageViewModel } from '../../campaigns-generated';

export class CampaignsOutageMainViewModel {
	readonly backUrl: string;

	constructor(model: CampaignsOutageViewModel) {
		this.backUrl = model.BackUrl;
	}
}
